import React from 'react';
import {
  Card, CardTitle, CardContent, CardHeader, CardGradientText,
} from '@/components/overseaHome/ui/Card';
import useIsMobile from '@/hooks/useIsMobile';
import VipCard from './VipCard';
import styles from './index.module.scss';

export default function Pricing() {
  const isMobile = useIsMobile();

  const style = isMobile ? { marginTop: '8px' } : {};
  return (
    <div className={styles.pricing} id="price">
      <Card style={{ paddingRight: '0px', paddingLeft: '0px' }}>
        <CardHeader style={{ paddingRight: '16px', paddingLeft: '16px' }}>
          <CardGradientText>
            Pricing Plan
          </CardGradientText>
          <CardTitle>Select your Plan</CardTitle>
        </CardHeader>
        <CardContent className={styles.vipCardContent} style={style}>
          <VipCard />
        </CardContent>
      </Card>
    </div>
  );
}
